import React from 'react'
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import { Link } from "react-router-dom";
import MemberBios from "../elements/service/MemberBios";
import { useTranslation } from "react-i18next";

const ScientificTeam = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="N01ZET Team - l'équipe N01ZET - Jean-Marie SIMON - Victor DEGBO - Valérie CAILLAUD - Marie-Héléne MORVAN - Anne-Marie CALMEIL - Philippe BOISDELET - Guy ROULLIER - Hugues FEYRIT - Gustavo HORNOS" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/*  Start Scientific Team  */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <div className="row pb-5 mb-5 bios-title-header">
                            <div className="col-lg-12 text-center">
                            <h2 className='title'>{t('WhoAreWe.scientificCommittee')}</h2>
                            </div>
                        </div>
                        <MemberBios
                        image = "/images/team/director.png"
                        link = "https://www.linkedin.com/in/jean-marie-simon-040a13/"
                        title = "Jean-Marie Simon"
                        description = {t('scientific.function.jea')}
                        text1 = {t('scientific.jea.text1')}
                        text2 = {t('scientific.jea.text2')}
                        text3 = {t('scientific.jea.text3')}
                        />
                    </div>
                    <div className='text-center pt-5'>
                        <Link className="btn-default btn-large" to='/about-us'>{t('WhoAreWe.teamReturn')}</Link>
                    </div>
                </div>
                
                {/*  End Scientific Team  */}                    
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default ScientificTeam;
